import CampaignIcon from '@mui/icons-material/Campaign';
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ChamadoChecklist } from '../../../types/new-form-filling/types';

export const ButtonChamado = ({ ticketConfig, chamados, setOpenModal }: { ticketConfig: { limit: number, mandatory: boolean }, chamados: ChamadoChecklist[], setOpenModal: Function }) => {
  const {t} = useTranslation();
  const verificaChamado = (ticketConfig: { limit: number, mandatory: boolean }) => {
    if (ticketConfig.mandatory && !chamados?.length) {
      return 'error';
    } if (ticketConfig && !chamados?.length) {
      return 'info';
    } return 'success';
  };
  return (
    <Button color={verificaChamado(ticketConfig)} onClick={() => setOpenModal(true)} endIcon={<CampaignIcon />} variant='contained'>{t('formFilling.openTicket')}</Button>
  );
};